import ApiService from "./base.api.service";
import store from "@/store";

class AdminApi extends ApiService {
  constructor() {
    super();
  }

  get baseURL() {
    return store.state.config.adminApiUrl;
  }
}

export default new AdminApi;
